import { AlertIcon, RenderHTML } from '@shared/ui-components';

import styles from './error-page-content-base.module.scss';

type ErrorPageContentProps = {
  actionsSlot?: React.ReactNode;
  message: string;
};

export const ErrorPageContentBase = ({ actionsSlot, message }: ErrorPageContentProps) => {
  return (
    <div className={styles['error-content']}>
      <AlertIcon className={styles['error-content__icon']} />
      <RenderHTML as="p" className={styles['error-content__message']} html={message} />
      {actionsSlot && <div className={styles['error-content__actions']}>{actionsSlot}</div>}
    </div>
  );
};
